import { render, staticRenderFns } from "./ThgYearSelector.vue?vue&type=template&id=2c511481&scoped=true"
import script from "./ThgYearSelector.vue?vue&type=script&lang=ts"
export * from "./ThgYearSelector.vue?vue&type=script&lang=ts"
import style0 from "./ThgYearSelector.vue?vue&type=style&index=0&id=2c511481&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c511481",
  null
  
)

export default component.exports